<template>
  <div
    class="bg-background-neutral-secondary w-full cursor-pointer rounded-2xl p-4"
    role="button"
    tabindex="0"
    @click="emit('open', item)"
    @keydown.enter.prevent="emit('open', item)"
    @keydown.space.prevent="emit('open', item)"
  >
    <FavoritesItemHeader :item="item" @remove="emit('remove', item)" />
  </div>
</template>

<script setup lang="ts">
  import { type WatchlistItem } from '@/features/favorites';

  import FavoritesItemHeader from './FavoritesItemHeader.vue';

  defineProps<{
    item: WatchlistItem;
  }>();

  const emit = defineEmits<{
    remove: [item: WatchlistItem];
    open: [item: WatchlistItem];
  }>();
</script>
